import GenericCreateForm from "../../components/GenericCreateForm";
function CreateBrand() {
  return (
    <GenericCreateForm
      title="Marca"
      endpoint="/brands"
      backTo="/brands"
    />
  );
}

export default CreateBrand;
